import { WHISLIST } from "../Type/type";

  const initialState = {
    Whislist: false,
  }; 
  
  export const uiReducer = (state = initialState, action) => {
  
    switch (action.type) {
  
      case WHISLIST:
        return {
          ...state,
          Whislist: action.payload,
        };
    
      default:
        return state;
    }
  };